export const config = {
  apiKey: 'AIzaSyDIoeBIBagbtZN_TYIC-xL0-jz2sBpSCNg',
  authDomain: 'etijah-5e2c9.firebaseapp.com',
  databaseURL: 'https://etijah-5e2c9.firebaseio.com',
  projectId: 'etijah-5e2c9',
  storageBucket: 'etijah-5e2c9.appspot.com',
  messagingSenderId: '411435056670'
}



// WEBPACK FOOTER //
// ./src/services/firebase.js